<template>
  <MessageBody/>
</template>

<script>
// @ is an alias to /src
import MessageBody from '@/components/MessageBody.vue'

export default {
  name: 'MessageView',
  components: {
    MessageBody
  }
}
</script>
